// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/rank.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'rank',
	post: false,
	require: function(config, filter) { return sorted('rank', filter) > 0 },
	run: function(config, filter, data, query) {
		query.where('g.game_rank', '>', 0)
		query.order('g.game_rank', sortReverse('rank', filter), sortPriority('rank', filter))
	}
}
